import TitleBanner from "../title-banner";
import Link from "next/link";
import Button from "../button";

export default function ({ page }) {
  return (
    <div className="template-vacancies">
      {page.extra_fields.title && page.extra_fields.text && (
        <TitleBanner
          title={page.extra_fields.title}
          text={page.extra_fields.text}
          cssClasses="pb-50"
        />
      )}
      <div className="rounded-edge-shape rounded-edge-shape--up--white" />
      <section className="pt-75 pb-75">
        <div className="container">
          <div className="frame frame--justify-sm-center">
            <div className="bit-xxs-12 bit-sm-11 bit-md-10 bit-lg-8 text-center pb-30">
              {page.extra_fields.title_above_vacancies && (
                <h2 className="pb-20">
                  {page.extra_fields.title_above_vacancies}
                </h2>
              )}
              {page.extra_fields.text_above_vacancies && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: page.extra_fields.text_above_vacancies,
                  }}
                />
              )}
            </div>
          </div>
          <div className="frame frame--justify-sm-center pb-30 pb-md-50">
            {page.extra_fields.vacancies &&
            page.extra_fields.vacancies.length ? (
              page.extra_fields.vacancies.map((vacancy) => {
                return (
                  <div
                    className="bit-xxs-12 bit-sm-11 bit-md-10 bit-lg-9"
                    key={vacancy.title}
                  >
                    <Link href={vacancy.url}>
                      <div className="template-vacancies__vacancy p-40 p-sm-50">
                        {vacancy.title && (
                          <h3
                            className="h4 pb-10"
                            dangerouslySetInnerHTML={{ __html: vacancy.title }}
                          />
                        )}
                        {vacancy.is_filled && (
                          <p className="template-vacancies__vacancy__is-filled">
                            Deze vacature is reeds gevuld
                          </p>
                        )}
                        {vacancy.excerpt && (
                          <div
                            className="pb-20 text--weight-normal"
                            dangerouslySetInnerHTML={{
                              __html: vacancy.excerpt,
                            }}
                          />
                        )}
                        <span className="button button--link template-vacancies__vacancy__link">
                          Bekijk vacature
                        </span>
                      </div>
                    </Link>
                  </div>
                );
              })
            ) : (
              <div className="bit-xxs-12">
                <p className="text--weight-normal text-center">
                  Er zijn momenteel geen openstaande vacatures.
                </p>
              </div>
            )}
          </div>

          <div className="frame">
            {page.extra_fields.cta_title && page.extra_fields.cta_text && (
              <div className="bit-xxs-12">
                <div className="template-vacancies__cta p-30 p-sm-40 p-md-50 pl-lg-75 pr-lg-75">
                  <div className="frame frame--align-md-flex-end m-0">
                    <div className="bit-xx-12 bit-md-8 p-0">
                      <p className="template-vacancies__cta__title">
                        {page.extra_fields.cta_title}
                      </p>
                      <div
                        className="pb-20 pb-md-0"
                        dangerouslySetInnerHTML={{
                          __html: page.extra_fields.cta_text,
                        }}
                      />
                    </div>
                    <div className="bit-xxs-12 bit-md-3 bit-offset-md-1 p-0">
                      {page.extra_fields.cta_link && (
                        <Button
                          button={page.extra_fields.cta_link}
                          classes="button button--white"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
